// Definición de defaults

export const defaultTipoOperacionFirma: TipoOperacionFirmaProps = {
    idTipoOperacionFirma:   0,
    descripcion:            '',
    activo:                 false
};

// Creación de interfaces

export interface TipoOperacionFirmaProps   {
    idTipoOperacionFirma:   number;
    descripcion:            string;
    activo:                 boolean;
}